export default {
  getEditPageState(state) {
    return state.editPageState;
  },
  getSectors(state) {
    return state.sectors;
  },
  getIndustries(state) {
    return state.industries;
  },
  getCities(state) {
    return state.cities;
  },
  getStudyFields(state) {
    return state.studyFields;
  },
  getCategories(state) {
    return state.categories;
  },
  getJobFunctions(state) {
    return state.jobFunctions;
  },
  getCertificationFields(state) {
    return state.certificationFields;
  },
  getAllServices(state) {
    return state.services;
  },
  getAllDepartments(state) {
    return state.departments;
  },
  getAllEmployeeRange(state) {
    return state.allEmployeeRange;
  },
  getAllEmployeeRangeList(state) {
    return state.allEmployeeRangeList;
  },
  getJobPostCategories(state) {
    return state.jobCategories;
  }
};